'use client'

import { useState } from 'react'
import { Card } from 'antd'
import {
  RequestAppointmentButton,
  RequestAppointmentModal,
  PhoneButton,
} from '@/src/components'
import { PhysicianBio } from '../PhysicianBio/PhysicianBio'

import { Physician } from '@/src/interfaces'

interface PhysiciansListProps {
  results: Physician[]
  geoLocation: {
    latitude: number
    longitude: number
  } | null
}

export const PhysiciansList = ({
  results,
  geoLocation,
}: PhysiciansListProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [selectedPhysician, setSelectedPhysician] = useState<Physician | null>(
    null
  )

  const handleRequestAppointment = (physician: Physician) => {
    setSelectedPhysician(physician)
    setIsModalVisible(true)
  }

  return (
    <>
      {results.map((physician, index) => (
        <Card
          key={physician.npi}
          data-testid='physician-card'
          role='article'
          style={{ marginBottom: 16, borderColor: 'lightGray' }}
        >
          <div className='block md:flex md:justify-between'>
            <PhysicianBio
              physician={physician}
              position={index + 1}
              geoLocation={geoLocation}
            />
            <div className='flex flex-col justify-between items-center gap-2 pt-4 md:items-end md:pt-0 md:gap-0 md:ml-8'>
              <div className='flex justify-start'>
                <RequestAppointmentButton
                  physician={physician}
                  position={index + 1}
                  onRequestAppointment={handleRequestAppointment}
                  buttonText='Request Appointment'
                />
              </div>
              <div className='flex justify-end'>
                {physician.phone && (
                  <PhoneButton
                    physician={physician}
                    position={index + 1}
                    text='View Phone Number'
                    color='primary'
                    variant='outlined'
                    className='w-48'
                  />
                )}
              </div>
            </div>
          </div>
        </Card>
      ))}
      {selectedPhysician && (
        <RequestAppointmentModal
          physician={selectedPhysician}
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          selectedPhysician={selectedPhysician}
          setSelectedPhysician={setSelectedPhysician}
        />
      )}
    </>
  )
}
